/* eslint-disable */
export const DISCRETE_TIME_FILTERS = [
    {
        text: 'YTD',
        type: 'year',
        active: true,
    },
    {
        text: 'MTD',
        type: 'month',
        active: false,
    },
    {
        text: 'DTD',
        type: 'day',
        active: false,
    },
];

export const defaultFailureParameters = [
    { id: "ai-supervisor", name: "AI supervisor checks", selected: false },
    { id: "weight", name: "Weight", selected: true },
    { id: "temperature", name: "Temperature", selected: false },
    { id: "visual", name: "Visual Quality", selected: false },
    { id: "ux", name: "UX App checklist", selected: false },
    { id: "ph", name: "pH", selected: false },
    { id: "smell", name: "Smell", selected: false },
    { id: "all", name: "All parameters", selected: false },
]

export const defaultFailureChartData = [
    { time: "12 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "1 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "2 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "3 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "4 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "5 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "6 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "7 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "8 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "9 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "10 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "11 AM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "12 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "1 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "2 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "3 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "4 PM", weight: 2000, temperature: 1500, density: 1800, hardness: 2200, moisture: 1500, expired: 1200 },
    { time: "5 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "6 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "7 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "8 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "9 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "10 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
    { time: "11 PM", weight: 0, temperature: 0, density: 0, hardness: 0, moisture: 0, expired: 0 },
]

export const defaultProducts = [
    { id: "1", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "2", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "3", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "4", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "5", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "6", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "7", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "8", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "9", name: "Chocolate Lava biscoff 500g", selected: false },
    { id: "10", name: "Chocolate Lava biscoff 500g", selected: false },
    
]
